<template>
  <div v-if="details">
    <Dialog
      v-model:visible="isVisible"
      modal
      :draggable="false"
      :closable="false"
      :dismissableMask="true"
      :pt="passThrough"
    >
      <template #header>
        <img
          :src="createIconUrl(details, true)"
          class="relative h-[100px] top-[-20px]"
          aria-hidden="true"
        />
        <span class="flex justify-between w-full">
          <span class="font-bold">{{ details.name }}</span>
          <span v-if="details.bikes.length > 1"
            >{{ details.bikes.length }}
            {{ $t('dbc-text-bikes-available') }}</span
          >
          <span v-if="details.bikes.length === 1"
            >{{ details.bikes.length }}
            {{ $t('dbc-text-bike-available') }}</span
          >
        </span>
        <button
          @click="isVisible = false"
          class="relative top-[-45px] right-[-10px] w-0 text-white bg-transparent border-none cursor-pointer"
          aria-label="Close"
        >
          <DbcSvg name="dbc-close" />
        </button>
      </template>
      <div class="flex flex-col gap-2xs overflow-scroll max-h-[50vh] m-4">
        <div v-for="bike in details.bikes">
          <DetailsViewListItem :bike="bike" />
        </div>
        <div v-if="details.bikes.length === 0">
          <p>{{ $t('dbc-headline-no-available-bikes') }}</p>
          <p class="text-xs">{{ $t('dbc-text-return-bike-at-station') }}</p>
        </div>
      </div>
    </Dialog>
  </div>
</template>

<script setup lang="ts">
import Dialog from 'primevue/dialog'

const props = defineProps<{
  details: Availability | null
}>()

const isVisible = defineModel<boolean>()

watch(
  () => props.details,
  () => {
    if (props.details) isVisible.value = true
  }
)

const passThrough = {
  root: {
    class: 'bg-gray w-[40rem] rounded-2xl max-tablet:w-[80%]',
  },
  mask: {
    class: 'bg-black/40',
  },
  header: {
    class: 'flex rounded-t-2xl h-[4rem] items-center bg-white p-4 text-xs',
  },
  headerActions: {
    class: 'bg-white rounded-t-2xl',
  },
}
</script>
